export default class CustomError extends Error {
  constructor(code) {
    super(code);
    this.code = code;
  }
}